import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { useSalonsDestroyMutation } from '../../../services/GLOWClient';

const DeleteSalon = ({ open, onClose, salon, onSuccess }) => {
  // Delete salon mutation
  const [destroySalon, { isLoading: isDeleting }] = useSalonsDestroyMutation();

  // Handle salon deletion
  const handleDeleteConfirm = async () => {
    if (!salon) return;
    
    try {
      await destroySalon({ salonId: salon.salon_id }).unwrap();
      
      // Call the success callback with the deleted salon info
      onSuccess(salon);
    } catch (error) {
      console.error('Failed to delete salon:', error);
      // Pass the error to the parent component
      onSuccess(null, error);
    } finally {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Confirmer la suppression</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Êtes-vous sûr de vouloir supprimer le salon "{salon?.name}"? Cette action est irréversible.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isDeleting}>
          Annuler
        </Button>
        <Button 
          onClick={handleDeleteConfirm} 
          color="error" 
          variant="contained"
          disabled={isDeleting}
        >
          {isDeleting ? <CircularProgress size={24} /> : 'Supprimer'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSalon;